import * as React from 'react';
import { Icon, IconType } from '@fluentui/react/lib/Icon';
import { registerIcons } from '@fluentui/react/lib/Styling';

export function initializeCustomIcons(): void {
    registerIcons({
        icons: {
            HRWeb: (
                <Icon
                    imageProps={{
                        src: './images/NavHrIcon.svg',
                        width: 20,
                    }}
                    iconType={IconType.Image}
                />
            ),
        },
    });
}
